import { Action, createAction, ThunkAction } from '@reduxjs/toolkit';
import { resetAction } from 'careand-redux/utils/makeResettable';
import { clearAllForms } from 'careand-redux/slices/rhfForms';
import { Device } from 'services/Native/Device';
import { navigationActions } from 'careand-redux/slices/ui/navigation';
import { removePushToken } from 'services/updatePushToken';
import { type AppDispatch, type RootState } from 'careand-redux/store';
import { goToLoginIfNeeded } from 'thunks/patients';
import { isPatientPortal } from 'services/PortalUtils';

const isPatient = isPatientPortal;

type LogoutPayload =
  | {
      previousUserId?: string;
      isManuallyTriggered?: boolean;
    }
  | undefined;

const logoutAction = createAction<LogoutPayload>('logout');

const logoutThunk = (payload?: LogoutPayload): ThunkAction<void, unknown, unknown, Action<any>> => {
  // console.log('LOGOUT', new Error().stack);
  //@ts-ignore
  return (dispatch: AppDispatch, getState: () => RootState) => {
    if (Device.isMobile()) {
      removePushToken();
      if (payload?.isManuallyTriggered) {
        Device.storeCredentials(undefined);
        Device.requestSetActiveUserId(undefined);
      }
    }
    dispatch(resetAction()); // resets all resettable slices
    dispatch(logoutAction(payload)); // dispatches logoutAction
    dispatch(navigationActions.resetState());
    dispatch(clearAllForms());
    if (!isPatient) {
      //@ts-ignore
      dispatch(goToLoginIfNeeded());
    }
  };
};

logoutThunk.action = logoutAction;

/**
 * Logout thunk and action
 * can be dispatched: `dispatch(logout())`
 * or listened in a slice: `builder.addCase(logout.action, () => { ... })`
 */
export const logout: typeof logoutThunk & { action: typeof logoutAction } = logoutThunk;
